import Box from "@mui/material/Box";
import { CPButton } from "./CPButton";
import { CPTitle } from "./CPTitle";

interface CPFormSubmit {
  title: string;
  boldTitle?: string;
  hint?: string;
  titleClassName?: string;
  labelButton: string;
  loading?: boolean;
  disabled?: boolean;
  handleSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
  children: React.ReactNode;
}

export const CPFormSubmit = ({
  title,
  boldTitle = "",
  hint,
  labelButton,
  loading,
  ...props
}: CPFormSubmit) => {
  return (
    <form noValidate onSubmit={props.handleSubmit} className="w-100">
      <CPTitle
        className={props.titleClassName}
        title={title}
        boldTitle={boldTitle}
        hint={hint}
      />

      {props.children}

      <Box>
        <CPButton
          label={labelButton}
          loading={loading}
          disabled={props.disabled}
        />
        
      </Box>
    </form>
  );
};
